// extracted by mini-css-extract-plugin
module.exports = {"comments":"R_ds","comments__list":"R_dt"};